import { Button } from '@/components/_ui/Button'
import T, { useTranslate } from '@/components/Helpers/Translate'
import { useModals } from '@/components/ModalManager/useModals'
import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'
import { useCopyReferralLink } from '@/lib/hooks/helpers/useCopyReferralLink'
import { generateProductDetailEventData } from '@/lib/services/mixpanel/helpers/generateProductDetailData'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import { cleanEventData } from '@/lib/services/mixpanel/utils/cleanEventData'
import useGlobalStore from '@/store/useGlobalStore'

type Props = {
  product: CosmicProductType
  selectedVariation: CosmicVariationType
}

type LinkType = 'standard' | 'focus'

export const SelectLinkType = ({ product, selectedVariation }: Props) => {
  const { translate } = useTranslate()

  const globalStore = useGlobalStore()
  const { modals } = useModals()

  const { copyReferralLink } = useCopyReferralLink()

  const handleLinkClick = (type: LinkType) => {
    copyReferralLink({ type })

    modals.closeModals()

    const eventData = generateProductDetailEventData(
      product,
      selectedVariation,
      type,
      globalStore,
    )

    mixpanelService
      .trackEvent(
        MixpanelEvent.USER_REFERRAL_LINK_COPIED,
        cleanEventData(eventData),
      )
      .catch(() => {})
  }

  const ShareSection = ({
    type,
    titleKey,
  }: {
    type: LinkType
    titleKey: string
  }) => (
    <div className="mb-2 rounded-lg border p-4">
      <div dangerouslySetInnerHTML={{ __html: translate(titleKey) }} />
      <Button
        variant={type === 'standard' ? 'secondary' : 'default'}
        className="mt-2"
        onClick={() => handleLinkClick(type)}
      >
        <T>{`copy_${type}_link`}</T>
      </Button>
    </div>
  )

  return (
    <div className="flex flex-col">
      <ShareSection type="focus" titleKey="share_focused_link" />
      <ShareSection type="standard" titleKey="share_referral_link" />
    </div>
  )
}
